export const topBarHeight = 64;
export const sideNavWidth = 260;
export const navbarHeight = 60;
export const sidenavCompactWidth = 80;
export const containedLayoutWidth = 1200;
export const broilerId = "d8105474-c5f7-4981-a435-32b307b6ee22";
export const layerId = "f89e98ef-7dfb-42a9-aa17-c822c0b5797e";
export const sonaliId = "6921262d-9457-4ba3-ae1a-1b43a955200f";
export const fieldOfficerRoleId = "cc3e8a32-7832-471e-863e-7e4b22456efe";
export const zonalManagerRoleId = "4c7e07f2-4d94-47b1-a2fb-544393f1a6b8";
export const apFeedCompanyId = "c6010bbd-aab2-4166-a7cd-d33ac844c65a";
export const farmerCustomerTypeId = "f723e5e7-85b2-4faf-b2b4-176fa4161f78";
export const dealerCustomerTypeId = "ad2d3003-c327-4822-949a-9b5ccea387c8";
export const chemistCustomerTypeId = "8d20c160-293a-46a1-b046-bc6758ee3421";
export const fishFarmCategoryId = "937D9E43-40C2-46DC-92EC-00CB9AEC7ED9";
export const poultryFarmCategoryId = "a85cbf89-32b7-4f93-aa06-79fd109872ed";
export const cattleFarmCategoryId = "6953d24b-b13d-4f57-b5bc-9e6e1be10f9f";
export const dealerTypeMain = 1;
export const dealerTypeSub = 2;
